import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../../utils/TestIds';
import { Button } from '../../Button';
import { TextButton } from '../../TextButton';
import { Typography } from '../../Typography';
import styles from './BottomSheetContentLayout.module.scss';
export const GetBottomSheetContentLayoutTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            BottomSheetContentLayoutTID: {
                HeaderSlot: 'bottom-sheet-header-slot',
                Header: 'bottom-sheet-header',
                FooterSlot: 'bottom-sheet-footer-slot',
                Footer: 'bottom-sheet-footer',
                PrimaryAction: 'bottom-sheet-primary-action',
                SecondaryAction: 'bottom-sheet-secondary-action'
            }
        }
    });
export function BottomSheetContentLayout(props) {
    var _footer_paddingGutter, _footer_paddingGutter1, _footer_primaryAction_testId, _footer_secondaryAction_testId;
    const { children, header, footer, contentClassName, contentGutter, contentPaddingTop, fillHeight } = props;
    const { BottomSheetContentLayoutTID } = useMemo(()=>GetBottomSheetContentLayoutTID(), []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": BottomSheetContentLayoutTID.HeaderSlot(),
                children: header && /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.header, {
                        [styles["".concat(header.gutter, "Gutter")]]: header.gutter,
                        [styles.startAligned]: header.align === 'start'
                    }),
                    "data-testid": BottomSheetContentLayoutTID.Header(),
                    style: {
                        paddingBottom: header.paddingBottom
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            weight: "normal",
                            testId: header.titleTestId,
                            children: header.title
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            skin: "secondary",
                            children: header.subtitle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.content, contentClassName, {
                    [styles["".concat(contentGutter, "Gutter")]]: contentGutter,
                    [styles.fillHeight]: fillHeight
                }),
                "data-testid": BottomSheetContentLayoutTID.Content(),
                style: {
                    paddingTop: contentPaddingTop
                },
                children: children
            }),
            /*#__PURE__*/ _jsx("div", {
                "data-testid": BottomSheetContentLayoutTID.FooterSlot(),
                children: footer && /*#__PURE__*/ _jsxs("div", {
                    "data-testid": BottomSheetContentLayoutTID.Footer(),
                    className: styles.footer,
                    style: {
                        paddingLeft: (_footer_paddingGutter = footer.paddingGutter) !== null && _footer_paddingGutter !== void 0 ? _footer_paddingGutter : 16,
                        paddingRight: (_footer_paddingGutter1 = footer.paddingGutter) !== null && _footer_paddingGutter1 !== void 0 ? _footer_paddingGutter1 : 16,
                        paddingTop: footer.paddingTop,
                        paddingBottom: footer.paddingBottom
                    },
                    children: [
                        footer.content,
                        footer.primaryAction && /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                                fluid: true,
                                roundness: "m",
                                onClick: footer.primaryAction.onClick,
                                disabled: footer.primaryAction.disabled,
                                testId: (_footer_primaryAction_testId = footer.primaryAction.testId) !== null && _footer_primaryAction_testId !== void 0 ? _footer_primaryAction_testId : BottomSheetContentLayoutTID.PrimaryAction(),
                                intent: footer.primaryAction.intent,
                                loading: footer.primaryAction.loading,
                                tooltip: footer.primaryAction.tooltip
                            }, footer.primaryAction.noBi ? {
                                noBi: true
                            } : {
                                bi: footer.primaryAction.bi
                            }), {
                                children: footer.primaryAction.text
                            }))
                        }),
                        footer.secondaryAction && /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({
                                skin: "primary",
                                underline: "none",
                                weight: "normal",
                                variant: "paragraph2",
                                onClick: footer.secondaryAction.onClick,
                                disabled: footer.secondaryAction.disabled,
                                testId: (_footer_secondaryAction_testId = footer.secondaryAction.testId) !== null && _footer_secondaryAction_testId !== void 0 ? _footer_secondaryAction_testId : BottomSheetContentLayoutTID.SecondaryAction()
                            }, footer.secondaryAction.bi ? {
                                bi: footer.secondaryAction.bi
                            } : {
                                noBi: true
                            }), {
                                children: footer.secondaryAction.text
                            }))
                        })
                    ]
                })
            })
        ]
    });
}
